import type { BdMapClickEvent } from './map-click.event';

export abstract class BdMapClickEventHandler {
  public abstract onClick(event: BdMapClickEvent): BdMapClickEvent;
}
